import { createStore } from 'vuex'
import coupons from './modules/coupons'
import detail_user from './modules/detail_user';
import products from './modules/products';
import customers from './modules/customers';
import transactions from './modules/transactions';
import coupon_transactions from './modules/coupon_transactions';
import branches from './modules/branches';
import loading from './modules/loading';
import userActivities from './modules/user_activities';
import reminders from './modules/reminders';
import categories from './modules/categories';

const store = createStore({
  modules: {
    coupons,
    detail_user,
    products,
    customers,
    transactions,
    coupon_transactions,
    loading,
    branches,
    userActivities,
    reminders,
    categories
  }
});

export default store;